var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 18,
    id: "katman_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "currentColor",
    d: "M256,93c-89.9,0-163,73.1-163,163c0,89.9,73.1,163,163,163s163-73.1,163-163C419,166.1,345.9,93,256,93z  M256,403.3c-81.2,0-147.3-66.1-147.3-147.3c0-81.2,66.1-147.3,147.3-147.3S403.3,174.8,403.3,256 C403.3,337.2,337.2,403.3,256,403.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "currentColor",
    d: "M502.8,243.9l-27-46.8V143c0-8.6-4.6-16.6-12.1-20.9l-46.8-27l-27-46.8c-4.3-7.4-12.3-12.1-20.9-12.1h-54.1 l-46.8-27c-7.3-4.2-16.8-4.2-24.1,0l-46.8,27h-54.1c-8.6,0-16.6,4.6-20.9,12.1l-27,46.8l-46.8,27c-7.4,4.3-12.1,12.3-12.1,20.9 v54.1l-27,46.8c-4.3,7.4-4.3,16.7,0,24.1l27,46.8v54.1c0,8.6,4.6,16.6,12.1,20.9l46.8,27l27,46.8c4.3,7.4,12.3,12.1,20.9,12.1h54.1 l46.8,27c3.6,2.1,7.8,3.2,12.1,3.2c4.3,0,8.4-1.1,12.1-3.2l46.8-27h54.1c8.6,0,16.6-4.6,20.9-12.1l27-46.8l46.8-27 c7.4-4.3,12.1-12.3,12.1-20.9v-54.1l27-46.8C507.1,260.6,507.1,251.4,502.8,243.9z M489.2,260.2l-28.1,48.6 c-0.7,1.2-1.1,2.5-1.1,3.9v56.2c0,3-1.6,5.8-4.2,7.3l-48.6,28.1c-1.2,0.7-2.2,1.7-2.9,2.9l-28.1,48.6c-1.5,2.6-4.3,4.2-7.3,4.2 h-56.2c-1.4,0-2.7,0.4-3.9,1l-48.6,28.1c-2.5,1.5-5.9,1.5-8.5,0l-48.6-28.1c-1.2-0.7-2.5-1-3.9-1h-56.2c-3,0-5.8-1.6-7.3-4.2 l-28.1-48.6c-0.7-1.2-1.7-2.2-2.9-2.9l-48.6-28.1c-2.6-1.5-4.2-4.3-4.2-7.3v-56.2c0-1.4-0.4-2.7-1.1-3.9l-28.1-48.6 c-1.5-2.6-1.5-5.8,0-8.5l28.1-48.6c0.7-1.2,1.1-2.5,1.1-3.9V143c0-3,1.6-5.8,4.2-7.3l48.6-28.1c1.2-0.7,2.2-1.7,2.9-2.9l28.1-48.6 c1.5-2.6,4.3-4.2,7.3-4.2h56.2c1.4,0,2.7-0.4,3.9-1l48.6-28.1c2.6-1.5,5.9-1.5,8.5,0l48.6,28.1c1.2,0.7,2.5,1,3.9,1h56.2 c3,0,5.8,1.6,7.3,4.2l28.1,48.6c0.7,1.2,1.7,2.2,2.9,2.9l48.6,28.1c2.6,1.5,4.2,4.3,4.2,7.3v56.2c0,1.4,0.4,2.7,1.1,3.9l28.1,48.6 c0,0,0,0,0,0C490.7,254.4,490.7,257.6,489.2,260.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "currentColor",
    d: "M342.6,196.1L229.1,307.8l-60.2-56c-3.2-2.9-8.1-2.8-11.1,0.4c-2.9,3.2-2.8,8.1,0.4,11.1l65.7,61.2 c1.5,1.4,3.4,2.1,5.3,2.1c2,0,4-0.8,5.5-2.2l118.9-117c3.1-3,3.1-8,0.1-11.1C350.7,193.1,345.7,193.1,342.6,196.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprove);
export default __webpack_public_path__ + "static/media/approve.169148f1d9a8b49195dc451f86d45507.svg";
export { ForwardRef as ReactComponent };